import { TbUsers } from 'react-icons/tb'
import { P } from '~/components-v2'
import {
  CompareGrid,
  CompareItem,
  CompareQuote,
  ComparisonCard,
  OmniLogo,
  StrategyLogo,
} from '~/components-v2/compete-comparison-card'

export const CompareCard4 = () => {
  return (
    <ComparisonCard
      className="icon-pink"
      icon={<TbUsers />}
      title="Self-service for your business users. Embedded analytics for your customers."
      subhead="Omni lets anyone self-serve in the way they prefer, whether that’s AI, point-and-click, spreadsheets, Excel formulas, or SQL. If users have to wait for specialists, they’ll export the data and find a workaround. Self-service keeps their work inside the model where rules still apply."
    >
      <CompareGrid
        id="omni-self-service"
        compareLogos={[<OmniLogo key={1} />, <StrategyLogo key={2} />]}
        compareItems={[
          [
            <CompareItem type="positive" key={1}>
              <P>
                <strong>Self-service with guardrails.</strong>{' '}
                <a
                  href="https://docs.omni.co/modeling/topics"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Topics
                </a>{' '}
                and{' '}
                <a
                  href="https://docs.omni.co/modeling/develop/data-access-control"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  permissions
                </a>{' '}
                constrain what AI and users can query, so business users can
                trust answers without routing through the data team.
              </P>
            </CompareItem>,
            <CompareItem type="negative" key={2}>
              <P>
                <strong>Authoring waits on specialists.</strong> Nothing gets
                built until a project designer lays the schema-object
                foundation, and every new dataset or definition waits in that
                same queue.
              </P>
            </CompareItem>,
          ],
          [
            <CompareItem type="positive" key={1}>
              <P>
                <strong>Familiar tools on live data.</strong>{' '}
                <a
                  href="https://docs.omni.co/analyze-explore/calculations"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Excel formulas
                </a>{' '}
                and{' '}
                <a
                  href="https://docs.omni.co/analyze-explore/spreadsheet-tabs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  spreadsheet tabs
                </a>{' '}
                work on live query data, results sync to Google Sheets, and{' '}
                <a
                  href="https://docs.omni.co/analyze-explore/sql"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  SQL is one click away
                </a>
                .
              </P>
            </CompareItem>,
            <CompareItem type="negative" key={2}>
              <P>
                <strong>Excel means exporting.</strong> Complaints{' '}
                <a
                  href="https://www.g2.com/products/strategy-one-formerly-microstrategy-one/reviews?utf8=%E2%9C%93&filters%5Bkeyphrases%5D=export"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  stretch back years
                </a>
                , and every export moves analysis outside your definitions and
                permissions.
              </P>
            </CompareItem>,
          ],
          [
            <CompareItem type="positive" key={1}>
              <P>
                <strong>Embedding that scales.</strong>{' '}
                <a
                  href="https://docs.omni.co/embed"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Signed iframe URLs
                </a>{' '}
                map to row-level permissions: thousands of external users, one
                report, each seeing only their own rows. Security is enforced by
                the platform, not rebuilt per customer.
              </P>
            </CompareItem>,
            <CompareItem type="negative" key={2}>
              <P>
                <strong>More infrastructure to run.</strong> Embedding Strategy
                means hosting and maintaining another server yourself.
              </P>
            </CompareItem>,
          ],
          [
            <CompareQuote
              key={1}
              type="positive"
              linkURL="https://omni.co/blog/case-study-synthesia"
              linkLabel="Edward Mancey, Director of Data at Synthesia"
              quote={
                <p>
                  Omni lets our data team get out of the way. Our business users
                  build reports I&apos;d never think of.
                </p>
              }
            />,
            <CompareQuote
              key={2}
              type="warn"
              linkURL="https://www.g2.com/survey_responses/strategy-one-formerly-microstrategy-one-review-11098386"
              linkLabel="Strategy customer"
              quote={
                <p>
                  Service is slow. Graphs break often and easily. Cannot handle
                  large datasets. [...] Takes a lot of tweaking to get to what
                  you actually want.
                </p>
              }
            />,
          ],
        ]}
      />
    </ComparisonCard>
  )
}
